import apiCep from '@/cflow/api/apiCEP';
class cep {

    buscar(cep) {
        return new Promise((resolve, reject) => {
            apiCep.get(cep+'/json').then((result) => {
                resolve(result.data);
            }).catch((error) => {
                reject(error);
            });
        });
    }

}
export default new cep();